import React from "react";
import type { HeroProps } from "../types";
import Image from "next/image";

const ContributorBio = ({
  title,
  text,
  image,
}: Pick<HeroProps, "image" | "title" | "text">) => {
  return (
    <div className="w-full">
      <div className="py-0 w-full">
        <div className="bg-primary border-brand border-b-4 mb-5 overflow-hidden py-5 px-5 w-full ">
          <div className="w-full p-1 py-10 pt-[70px] md:pt-6 pb-6 content-center container max-w-[950px]">
            {image?.sourceUrl ? (
              <div className="w-full !h-[120px] md:w-[120px] h-auto md:h-full content-center md:float-left">
                <Image
                  layout="responsive"
                  priority={true}
                  src={image.sourceUrl}
                  alt={image.altText || ""}
                  width={120}
                  height={120}
                  className="aspect-square object-cover content-center !h-[120px] lg:float-left max-w-[120px] max-h-[120px] md:max-w-[120px] md:max-h-[120px] mx-auto sm:m-auto rounded-full"
                />
              </div>
            ) : null}
            <div className="w-full md:w-auto inline-block h-auto md:h-full lg:float-left">
              <h1 className="w-full content-center lg:text-left text-4xl text-white font-bold text-center md:ml-4 mt-0 pt-4">
                {title}
              </h1>
              <p className="w-fullcontent-center lg:text-left clear-all text-white text-center md:ml-4 md:float-left">
                {text}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContributorBio;
